import { jsx as _jsx } from "react/jsx-runtime";
const Info = ({ className, iconColor = 'currentColor', }) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", className: className, children: _jsx("path", { stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M12 16v-4M12 8h.01" }) }));
};
export default Info;
//# sourceMappingURL=info.js.map